<template>
  <div id="app" v-cloak>
    <div v-if="!isReady" class="loading-screen">
      <img src="@/assets/image/loader.png" alt="Loading..." class="loading-logo" />
    </div>

    <div v-else class="main-content">
      <Navbar @change-lang="toggleLang" />
      <HeroSection class="section" />
      <AboutSection class="section" />
      <ValuesSection class="section" />
      <FeaturesSection class="section" />
      <ServicesSection class="section" />
      <ContactSection class="section" />
      <FooterSection class="section" />
    </div>
  </div>
</template>

<script>
import { ref, onMounted, nextTick, watch } from "vue";
import Navbar from "./components/Navbar.vue";
import HeroSection from "./components/HeroSection.vue";
import AboutSection from "./components/AboutSection.vue";
import ValuesSection from "./components/ValuesSection.vue";
import FeaturesSection from "./components/FeaturesSection.vue";
import ServicesSection from "./components/ServicesSection.vue";
import ContactSection from "./components/ContactSection.vue";
import { useI18n } from 'vue-i18n';
import FooterSection from "@/components/FooterSection.vue";

export default {
  components: {
    FooterSection,
    Navbar,
    HeroSection,
    AboutSection,
    ValuesSection,
    FeaturesSection,
    ServicesSection,
    ContactSection,
  },
  setup() {
    const isReady = ref(false);

    document.dir = "rtl";

    onMounted(() => {
      // وقت تحميل اللوجو قبل عرض المحتوى
      setTimeout(() => {
        isReady.value = true;
      }, 1500);
    });

    // لما isReady تبقى true، نضيف visible لكل .section تدريجيًا
    watch(isReady, async (val) => {
      if (val) {
        await nextTick();
        const fadeEls = document.querySelectorAll(".section");
        fadeEls.forEach((el, i) => {
          setTimeout(() => el.classList.add("visible"), i * 150); // هنا التأخير بين كل سكشن
        });
      }
    });

    const { locale } = useI18n();

    const toggleLang = (lang) => {
      locale.value = lang;
      document.dir = lang === 'ar' ? 'rtl' : 'ltr';
    };

    return { isReady, toggleLang };
  },
};
</script>

<style>
[v-cloak] {
  display: none;
}
html {
  scroll-behavior: smooth;
}
.loading-screen {
  width: 100vw;
  height: 100vh;
  background-color: #0f172a;
  display: flex;
  align-items: center;
  justify-content: center;
}
.loading-logo {
  width: 200px;
  animation: pulse 1.5s infinite ease-in-out;
  filter: brightness(0) invert(1);
}
@keyframes pulse {
  0%, 100% { opacity: 0.5; transform: scale(0.95); }
  50% { opacity: 1; transform: scale(1); }
}
.section {
  opacity: 0;
  transform: translateY(40px);
  transition: all 0.8s ease;
}

.section.visible {
  opacity: 1;
  transform: translateY(0);
}

</style>
